import React from 'react';
import { SpotlightTransition } from '@atlaskit/onboarding';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import messages from './messages.tsx';

type Props = {
	showOnboarding: boolean;
	onDismiss?: () => void;
};

const InlineCreateOnboardingSpotlight = ({ showOnboarding, onDismiss }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<SpotlightTransition>
			{showOnboarding && (
				<JiraSpotlight
					actions={[
						{
							onClick: onDismiss,
							text: formatMessage(messages.onboardingDismiss),
						},
					]}
					heading={formatMessage(
						fg('jira-issue-terminology-update-m4')
							? messages.onboardingHeaderIssueTerminologyRefreshM4
							: messages.onboardingHeader,
					)}
					target="inline-create-trigger"
					key="inline-create-trigger"
					messageType="engagement"
					dialogPlacement="top right"
					messageId={
						(fg('jira-issue-terminology-update-m4')
							? messages.onboardingDescriptionIssueTerminologyRefreshM4
							: messages.onboardingDescription
						).id
					}
					dialogWidth={275}
				>
					{formatMessage(
						fg('jira-issue-terminology-update-m4')
							? messages.onboardingDescriptionIssueTerminologyRefreshM4
							: messages.onboardingDescription,
					)}
				</JiraSpotlight>
			)}
		</SpotlightTransition>
	);
};

export default InlineCreateOnboardingSpotlight;
